module.exports = __webpack_public_path__ + "static/media/presentation.1af2d662.svg";